const common = {
  site: {
    name: '91美',
    tagline: '您值得信赖的美业服务平台',
    description: '汇聚海量优质美容、美发、美甲、美体项目，为您提供一站式美丽解决方案',
  },
  nav: {
    home: '首页',
    categories: '服务分类',
    articles: '美业资讯',
    about: '关于我们',
    contact: '联系我们',
  },
  hero: {
    title: '发现你的美，从这里开始',
    subtitle: '汇聚城市优质美业门店，美容、美发、美甲、美体，一站预约，轻松变美',
    ctaExplore: '探索服务',
    ctaAbout: '了解我们',
  },
  categories: {
    title: '服务分类',
    subtitle: '涵盖美容、美发、美甲、美体等全品类美业服务',
    all: '全部',
    beauty: '美容',
    hair: '美发',
    nail: '美甲',
    body: '美体',
  },
  services: {
    title: '精选服务',
    subtitle: '严选优质门店，品质有保障',
    viewDetail: '查看详情',
    booking: '立即预约',
  },
  articles: {
    title: '美业资讯',
    subtitle: '获取最新美业动态与护理知识',
    readMore: '阅读全文',
    viewAll: '查看全部文章',
    relatedArticles: '相关文章',
    publishedAt: '发布时间',
  },
  about: {
    title: '关于91美',
    brandStory: '品牌故事',
    mission: '我们的使命',
    values: '核心价值观',
    contact: '联系我们',
    contactDesc: '如有任何问题或合作意向，欢迎联系我们',
  },
  contact: {
    name: '姓名',
    email: '邮箱',
    phone: '电话',
    message: '留言内容',
    submit: '提交',
    submitting: '提交中...',
    success: '提交成功！我们会尽快与您联系。',
    error: '提交失败，请稍后重试。',
    placeholder: {
      name: '请输入您的姓名',
      email: '请输入您的邮箱',
      phone: '请输入您的电话',
      message: '请输入您的留言（500字以内）',
    },
  },
  footer: {
    copyright: '© 2026 91美 版权所有',
    about: '关于91美',
    services: '服务项目',
    support: '帮助中心',
    privacy: '隐私政策',
    terms: '服务条款',
    followUs: '关注我们',
    hotline: '客服热线',
    address: '公司地址',
    addressValue: '北京市朝阳区建国路88号SOHO现代城A座',
    phoneValue: '400-123-4567',
    emailValue: 'service@91mei.com',
  },
  breadcrumb: {
    home: '首页',
    categories: '服务分类',
    articles: '美业资讯',
    about: '关于我们',
  },
  cta: {
    title: '准备好开始你的美丽之旅了吗？',
    subtitle: '加入91美，发现身边最好的美业门店与达人',
    button: '立即体验',
  },
  whyUs: {
    title: '为什么选择91美',
    subtitle: '四大优势，让美丽更简单',
    quality: '严选品质',
    qualityDesc: '平台严格审核入驻门店，确保服务品质',
    price: '透明价格',
    priceDesc: '所有项目明码标价，拒绝隐形消费',
    convenient: '便捷预约',
    convenientDesc: '在线快速预约，省时省力更省心',
    guarantee: '售后保障',
    guaranteeDesc: '完善的售后体系，消费无忧',
  },
  breadcrumbCategoryAll: '全部服务',
};

export default common;